import moment from 'moment-timezone';

export const formatDate = date => {
  // We try because Intl API isn't available in every modern browser
  // (looking at you, IE10)
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return `${moment(date).format('llll')} ${moment.tz(timezone).format('z')}`;
  }
  catch (err) {
    return moment(date).format('llll');
  }
};
